import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m13.186 2.081 5 7 1.628-1.162-5-7zm3.663 9.178-7-6 1.302-1.518 7 6zM7.074 9.905l8.5 4 .852-1.81-8.5-4zm7.71 6.571-9-2 .433-1.952 9 2-.434 1.952ZM3.5 15h-2v8h18v-8h-2v6h-14zM6 19h9v-2H6z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandSoftwareDevelopmentStackoverflow = { render };
export {
  brandSoftwareDevelopmentStackoverflow as default,
  render
};
//# sourceMappingURL=brand-software-development-stackoverflow.svg.js.map
